import apiClient, { Request } from '@oscar/request';
import { RequestAction, ResponseData } from './typed';

const validateRequest = (request: Request) => {
  const { transformRequest, data, ...remain } = request;

  let nextData = data;
  if (transformRequest && transformRequest instanceof Function) {
    nextData = transformRequest(nextData);
  }
  return {
    ...remain,
    data: nextData,
  };
};

const fetchData = (payload: RequestAction) => {
  return apiClient
    .request<ResponseData<{ [index: string]: any }>>(
      validateRequest(payload.request)
    )
    .then((data) => {
      return {
        formName: payload.metadata.form,
        name: payload.request.name,
        data: data?.data ? data?.data : data,
      };
    });
};

const submitData = (payload: RequestAction) => {
  return apiClient
    .request<ResponseData<{ [index: string]: any }>>(
      validateRequest(payload.request)
    )
    .then((data) => {
      return {
        formName: payload.metadata.form,
        name: payload.request.name,
        data,
      };
    });
};

const service = {
  fetchData,
  submitData,
};

export default service;
